var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import '@mux/mux-video';
export const S4XMuxVideo = (_a) => {
    var { muxPlaybackId, playing, muted = true, loop = false, autoPlay = false } = _a, props = __rest(_a, ["muxPlaybackId", "playing", "muted", "loop", "autoPlay"]);
    const ref = useRef();
    useEffect(() => {
        var _a, _b, _c, _d;
        if (ref.current) {
            ref.current.muted = muted;
            ref.current.loop = loop;
            ref.current.autoplay = autoPlay;
        }
        if (playing && ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.paused)) {
            (_b = ref.current) === null || _b === void 0 ? void 0 : _b.play();
        }
        if (!playing && !((_c = ref.current) === null || _c === void 0 ? void 0 : _c.paused)) {
            (_d = ref.current) === null || _d === void 0 ? void 0 : _d.pause();
        }
    }, [playing, ref, muted, loop, autoPlay]);
    return (React.createElement("mux-video", Object.assign({ ref: ref, src: `https://stream.mux.com/${muxPlaybackId}.m3u8#t=0.001`, poster: props.poster ||
            `https://image.mux.com/${muxPlaybackId}/thumbnail.jpg?time=.001`, playsInline: true, preload: "auto", tabIndex: -1 }, props)));
};
//# sourceMappingURL=S4XMuxVideo.js.map